export default {
  compareYears: 'Comparar años',
  granularity: 'Granularidad',
  monthly: 'Mensual',
  quarterly: 'Trimestral',
  weekly: 'Semanal'
}
